export default __webpack_public_path__ + "static/media/info.626706b3.mp3";